export enum UseRole {
  Sales = '0',
  Dealer = '1',
  Agent = '2',
}
